var exports = {
  "R": "xaee3c4fa--f0ad3c--main-gallery",
  "M": "xaee3c4fa--f0ad3c--slide",
};

module.exports = exports;
